import { useSearchParams } from 'react-router-dom';
import LegacyContractRenewal from './index';
import RenewalJourneyPage from './journey/RenewalJourneyPage';

/**
 * `/contract/renewal/:contractId` — a UI 2026 é o padrão; o legado só abre com `?legacy=true`
 * (mesma convenção da Home e do PersonalCoverage), para rollback rápido durante a transição.
 */
export default function RenewalRoute() {
  const [searchParams] = useSearchParams();
  const legacy = searchParams.get('legacy') === 'true';

  return legacy ? <LegacyContractRenewal /> : <RenewalJourneyPage />;
}
